import { isNotNil } from '@flowio/is';
import keys from './keys';

type CreateInlineWindowElementsParams = {
  url: string;
  method: string;
  data?: Record<string, string>;
  iframeStyle?: Record<string, string>;
};

function getIframeName(): string {
  return `flow_displayInlineWindowFrame_${Math.round(Math.random() * 200)}`;
}

export function createInlineWindowElements(
  params: CreateInlineWindowElementsParams,
): [HTMLIFrameElement, HTMLFormElement] {
  const iframe = document.createElement('iframe');
  const iframeStyle = {
    border: 'none',
    width: '100%',
    height: '100%',
    minHeight: '400px',
    ...params.iframeStyle,
  };
  const iframeName = getIframeName();
  iframe.id = 'flow_displayInlineWindowFrame';
  iframe.name = iframeName;
  // eslint-disable-next-line no-script-url
  iframe.src = 'javascript:false;';
  keys(iframeStyle).forEach((styleKey) => {
    iframe.style[styleKey] = iframeStyle[styleKey];
  });

  const form = document.createElement('form');
  form.action = params.url;
  form.target = iframeName;
  form.id = 'flow_displayInlineWindowForm';
  form.name = 'flow_displayInlineWindowForm';
  form.method = params.method.toLowerCase();

  if (isNotNil(params.data)) {
    keys(params.data).forEach((key) => {
      const formDataInput = document.createElement('input');
      formDataInput.type = 'hidden';
      formDataInput.name = String(key);
      formDataInput.value = params.data![key];
      form.appendChild(formDataInput);
    });
  }

  return [iframe, form];
}

type CreateExecuteScriptElementsParams = {
  script: string;
};

export function createExecuteScriptElement(
  params: CreateExecuteScriptElementsParams,
): HTMLIFrameElement {
  const iframe = document.createElement('iframe');
  iframe.id = 'flow_executeScriptFrame';
  iframe.style.border = 'none';
  iframe.style.width = '1px';
  iframe.style.height = '1px';
  iframe.style.visibility = 'hidden';
  iframe.style.position = 'absolute';
  // This mechanism is deliberate as it seems to be the only way to allow create a <form>
  // and <script> method and have them executed by the browser. The form and script are sent
  // to use as part of a string blob sent via Fiserv and we're not expected to altar.
  iframe.src = `data:text/html;charset=utf-8,${encodeURI(params.script)}`;

  return iframe;
}
